import React from 'react';
import Periods from 'components/app/erp/Periods';

// Route-level page entry for ERP Periods.
const PeriodPage = () => <Periods />;

export default PeriodPage;
